<div class="-oneX-container">
    <div class="-oneX-row -oneX-justify-content-center">

    <div class="-oneX-col-10">

        <table class="-oneX-table--standard" aria-label="Standard table">
            <thead class="-oneX-thead">
                <tr class="-oneX-tr">
                    <th class="-oneX-th--col">Claim Number</th>
                    <th class="-oneX-th--col">Date of Loss</th>
                    <th class="-oneX-th--col">First Name</th>
                    <th class="-oneX-th--col">Last Name</th>
                </tr>
            </thead>
            <tbody class="-oneX-tbody">
                <tr class="-oneX-tr" *ngFor="let claim of claimsArray;  let i = index ;">
                    <td class="-oneX-td"><a class="-oneX-link--inline" [routerLink]="" (click)="searchClaim(claimsArray[i].claim, claimsArray[i].dol, claimsArray[i].firstName ,claimsArray[i].lastName);">{{claimsArray[i].claim}} </a></td>
                    <td class="-oneX-td">{{claimsArray[i].dol}}</td>
                    <td class="-oneX-td">{{claimsArray[i].firstName}}</td>
                    <td class="-oneX-td">{{claimsArray[i].lastName}}</td>
                </tr>
            </tbody>
        </table>
    </div>
    </div>
</div>